module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle4.png?b84f1844c02a5a3f4b0f617663a994f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle4.png
// module id = 817
// module chunks = 0